import { createSlice } from '@reduxjs/toolkit';

import { CourseTypes, INITIAL_LIST_PARAMS } from 'config';
import { CourseState } from '../../types/course';

const initialState: CourseState = {
  isLoading: false,
  courseList: {},
  allCourses: [],
  courseListParams: { ...INITIAL_LIST_PARAMS, course_type: CourseTypes.TUTORIAL },
};

const slice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    tutorialStartLoading(state) {
      state.isLoading = true;
    },

    getAllCoursesSuccess(state, action) {
      state.allCourses = action.payload;
    },

    tutorialHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    tutorialResetError(state) {
      state.error = undefined;
    },

    getTutorialListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    getTutorialSuccess(state, action) {
      state.isLoading = false;
      state.course = action.payload;
    },

    setTutorialListParams(state, action) {
      state.courseListParams = action.payload;
    },

    clearTutorial(state) {
      state.course = undefined;
    },

    clearTutorialList(state) {
      state.courseList = {};
    },

    clearTutorialParameters(state) {
      state.courseListParams = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  tutorialStartLoading,
  tutorialHasError,
  tutorialResetError,
  getTutorialListSuccess,
  getTutorialSuccess,
  getAllCoursesSuccess,
  setTutorialListParams,
  clearTutorial,
  clearTutorialParameters,
  clearTutorialList,
} = slice.actions;
